<template>
    <b-container>
        <b-card class="mt-4 mb-4">
            <standard-table ref="table"
                            :items="items"
                            :fields="getFields()"
                            :theadTrClass="'first-3-table-cols'"

                            :row-before-search="{cols: 12,sm: 12,md: 12,lg: 4,xl: 4,order: 1,orderSm: 1,orderMd: 1,orderLg: 3,orderXl: 3}"
                            :row-search="{cols: 12,sm: 12,md: 12,lg: 4,xl: 4,order: 1,orderSm: 2,orderMd: 2,orderLg: 1,orderXl: 1}"
                            :row-after-search="{cols: 12, sm: 12, md: 12, lg: 4, xl: 4, order: 2, orderSm: 3, orderMd: 3, orderLg: 2, orderXl: 2}"

                            :row-pagination="{cols: 12, sm: 12, md: 6, lg: 5, xl: 5}"
                            :row-between-pagination="{cols: 12, sm: 12, md: 1, lg: 1, xl: 4}"
                            :row-per-page="{cols: 12, sm: 12, md: 5, lg: 3, xl: 2}"
                            :row-after-per-page="{cols: 12, sm: 12, md: 12, lg: 3, xl: 1}"

                            fullWidth="true"
                            noContainerPadding="true"
                            @rowInfo="showRowInfo"
                            @rowEdit="pushToEdit"
                            @rowDelete="deleteItem">

                <b-container slot="row-before-search" class="mw-100 p-0">
                    <b-row align-h="end">
                        <b-col cols="auto">
                            <b-button v-on:click="pushToEdit()" class="mb-3 b-c-blue" id="add-section">
                                {{$t('message.add')}}
                            </b-button>
                        </b-col>
                    </b-row>
                </b-container>

                <b-container slot="row-after-per-page" class="mw-100 p-0">
                    <b-row>
                        <b-col>
                            <b-button class="float-right mt-3 mt-md-0 mt-lg-0 mt-xl-0" id="excel-button" @click="$refs.table.excel($tc('message.section', 2))">Excel</b-button>
                        </b-col>
                    </b-row>
                </b-container>

                <b-container slot="row-after-search" class="mw-100 p-0">
                    <b-row>
                        <b-col>
                            <b-button v-on:click="resetFilters()" class="b-c-green mb-2 mr-2" id="reset-filters">
                                {{$t('message.resetFilters')}}
                            </b-button>

                            <b-button @click="showCollapse = !showCollapse" :class="showCollapse ? 'b-c-red mb-2 mr-2' : 'b-c-green mb-2 mr-2'" id="show-filters">
                                <span v-show="!showCollapse" class="when-opened">{{$t('message.show')}} {{$tc('message.filter', 2).toLowerCase()}}</span>
                                <span v-show="showCollapse" class="when-closed">{{$t('message.hide')}} {{$tc('message.filter', 2).toLowerCase()}}</span>
                            </b-button>
                        </b-col>
                    </b-row>
                </b-container>

                <b-container slot="after-search" class="mw-100 p-0">
                    <b-collapse id="my-collapse" v-model="showCollapse">
                        <b-container class="mw-100 m-0 p-0">
                            <b-row>
                                <b-col cols="12" sm="12" md="6" lg="4" xl="3">
                                    <b-form-group :label="`${$tc('message.structure', 1)}`">
                                        <v-select :options="structureOptions"
                                                  :reduce="obj => obj.id"
                                                  label="den_sintetica"
                                                  v-model="structureFilter">
                                        </v-select>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-container>
                    </b-collapse>
                </b-container>
            </standard-table>
        </b-card>

        <b-modal ref="infoModal" id="infoModal" :title="`${$tc('message.details', 1)}`">
            <b-container>
                <b-row>
                    <b-col cols="12" sm="12" md="12" lg="12" xl="12">
                        <div class="d-flex">
                            <h6><b>{{$tc('message.description', 1)}}</b></h6>
                            <h6 class="ml-2">{{infoItem.descrizione || $tc('message.emptyValue')}}</h6>
                        </div>
                    </b-col>

                    <b-col cols="12" sm="12" md="12" lg="12" xl="12">
                        <div class="d-flex">
                            <h6><b>{{$tc('message.structure', 1)}}</b></h6>
                            <h6 class="ml-2">{{infoItem.nome_struttura || $tc('message.emptyValue')}}</h6>
                        </div>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12" sm="12" md="12" lg="12" xl="12">
                        <div class="d-flex">
                            <h6><b>{{$tc('message.note', 2)}}</b></h6>
                            <h6 class="ml-2">{{infoItem.note || $tc('message.emptyValue')}}</h6>
                        </div>
                    </b-col>
                </b-row>
            </b-container>

            <div slot="modal-footer" class="w-100 justify-content-end d-flex">
                <b-button class="b-c-green" @click="$refs.infoModal.hide()"> Ok </b-button>
            </div>
        </b-modal>
    </b-container>
</template>

<script>
  import Vue from 'vue'
  import _ from 'lodash'

  export default {
    name: 'Section',
    created () {
      this.fetchData()
    },
    updated () {
      this.$root.$emit('checkExcel')
    },
    watch: {
      structureFilter (obj) {
        this.getItems(obj)
      }
    },
    data () {
      return {
        structureOptions: [],
        structureFilter: null,
        showCollapse: false,
        items: [],
        originalItems: [],
        infoItem: {}
      }
    },
    methods: {
      fetchData () {
        this.$root.$emit('activeLoader', true)
        this.getOptions().then(() => {
          this.getSections().then(() => {
            this.$root.$emit('activeLoader', false)
          })
        })
      },
      getOptions () {
        const axiosArray = []
        axiosArray.push(this.getStructure())
        return Vue.myAll(axiosArray)
      },
      getStructure () {
        return Vue.myGet(this, '/struttura', 'strutture').then((structures) => {
          this.structureOptions = structures
          return true
        }).catch(error => {
          Vue.manageErrors(this, error)
          return true
        })
      },
      getSections () {
        this.items = []
        this.originalItems = []
        return Vue.myGet(this, '/sezione', 'sezioni').then((sections) => {
          const editedItems = []
          sections.forEach(section => {
            const editedItem = section
            const foundedStructure = _.find(this.structureOptions, obj => obj.id === section.id_struttura)
            if (foundedStructure) editedItem.nome_struttura = foundedStructure.den_sintetica
            editedItems.push(editedItem)
          })
          this.items = editedItems
          this.originalItems = _.cloneDeep(editedItems)
          return true
        }).catch(error => {
          Vue.manageErrors(this, error)
          return true
        })
      },
      getFields () {
        return [
          { key: 'info', label: '' },
          { key: 'edit', label: '' },
          { key: 'delete', label: '' },
          { key: 'descrizione', label: `${this.$tc('message.description', 1)}`, sortable: true, sortDirection: 'desc' },
          { key: 'nome_struttura', label: `${this.$tc('message.structure', 1)}`, sortable: true, sortDirection: 'desc' },
          { key: 'note', label: `${this.$tc('message.note', 1)}`, sortable: true, sortDirection: 'desc', hideInTable: true }
        ]
      },
      showRowInfo (event) {
        this.infoItem = event && event.item
        if (this.$refs.infoModal) this.$refs.infoModal.show()
      },
      pushToEdit (event) {
        const item = event && event.item
        item && item.id ? this.$router.push({
          name: 'EditSection',
          params: { id: item.id }
        }) : this.$router.push({
          name: 'EditSection',
          params: { id: 'new' }
        })
      },
      deleteItem (event) {
        const item = event && event.item
        if (item && item.id) {
          this.$root.$emit('deleteItem', { description: item.ragione_sociale, path: `/sezione/${item.id}`, redirect: this.$route.path })
        }
      },
      resetFilters () {
        this.structureFilter = null
        this.$refs.table.resetSearch()
      },
      getItems (structure) {
        let editedItems = _.cloneDeep(this.originalItems)
        if (structure) editedItems = _.filter(editedItems, obj => obj.id_struttura === structure)
        this.items = editedItems
      }
    }
  }
</script>
